import React from "react";
import overview from "../../../../Assets/Images/Overview.png";
import user1 from "../../../../Assets/Images/selfuser2.png";
import user2 from "../../../../Assets/Images/selfuser1.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";

const styles = {
  pageWrapper: {
    backgroundColor: "rgb(255, 255, 255)",
  },
  section: {
    margin: "0px",
    minHeight: "542px",
    paddingTop: "12px",
  },
  title: {
    color: "#00577D",
    fontFamily: "Helvetica, sans-serif",
    fontWeight: 700,
    fontStyle: "Bold",
    fontSize: "18px",
    leadingTrim: "NONE",
    lineHeight: "24px",
    marginTop: 0,
    marginBottom: "16px",
    letterSpacing: "0px",
    textTransform: "uppercase",
  },
  contentRow: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
  },
  imageColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  userImage: {
    width: "102px",
    height: "153px",
  },
  paragraph: {
    color: "#000000",
    fontFamily: "Helvetica, sans-serif",
    fontSize: "10px",
    fontWeight: "400",
    lineHeight: "14px",
    marginTop: 0,
    marginBottom: "12.8px",
  },
   paragraph1: {
    color: "#000000",
    fontFamily: "Helvetica, sans-serif",
    fontSize: "10px",
    fontWeight: "400",
    lineHeight: "14px",
    marginTop: 0,
    marginBottom: "12.8px",
    maxWidth:"60ch"
  },
};

export default function Overview({ pageNumber, reportType, apiData }) {
  return (
    <div className="overview-section" style={styles.pageWrapper}>
      <HeaderPreview apiData={apiData} />
      <div className="overview-section" style={styles.section}>
        <h2 className="section-title" style={styles.title}>
          OVERVIEW
        </h2>

        <div style={styles.contentRow}>
          <div style={styles.imageColumn}>
            <img style={styles.userImage} src={user1} alt="user" />
            <img style={styles.userImage} src={user2} alt="user" />
          </div>
          <div>
            <p style={styles.paragraph1}>
              Quadrant Flow™ is a validated and reliable psychometric assessment built on the five principles of the Human Operating System™ (HOS). Dr. Rob Murray and Jack Nicholson created this model to help leaders, teams, and organizations recover the Heart, Soul, Mind, and Strength™ of their life and leadership.
            </p>
            <p style={styles.paragraph}>
              It is designed for businesses, coaches, consultants, churches, and nonprofits. The goal is to strengthen alignment, improve culture, and increase impact.
            </p>
            <p style={styles.paragraph}>
              Quadrant Flow™ is not static. It measures movement in real time and shows how you navigate life and leadership.
            </p>
            <p style={styles.paragraph}>
              When you learn to live and lead from all four quadrants instead of getting stuck in one, something powerful happens. You integrate. You become whole. This creates a healthier culture, stronger collaboration, higher retention, and better results.
            </p>
            <p style={styles.paragraph}>
              This assessment helps you discover your greatest potential and contribution. It improves how you understand yourself and others.
            </p>
            <p style={styles.paragraph}>
              Human beings are wired for meaning and significance. Quadrant Flow™ helps uncover your unique pattern of movement so you can begin a clear and purposeful journey of growth.
            </p>
          </div>
        </div>



      </div>
      <FooterPreview reportType={reportType} pageNumber={pageNumber} />
    </div>
  );
}
